import { Button } from "@/components/ui/button";
import { ArrowDown, Sparkles } from "lucide-react";

const HERO_BG =
  "https://static.prod-images.emergentagent.com/jobs/31d155ce-47a0-43dd-83bf-91a719a86bf9/images/d01aa99c70124ebf8d67bd6c9b5fd24e325d0c04c7ee63b1b1c79d291e4c8294.png";

export default function Hero({ onPrimaryClick }) {
  return (
    <section
      className="relative isolate overflow-hidden grain"
      data-testid="hero-section"
    >
      <div
        className="absolute inset-0 -z-10 bg-cover bg-center opacity-60"
        style={{ backgroundImage: `url(${HERO_BG})` }}
      />
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-[#0A0F1C]/60 via-[#0A0F1C]/80 to-[#0A0F1C]" />

      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pt-16 sm:pt-24 lg:pt-32 pb-20 lg:pb-28">
        <div className="max-w-4xl">
          <div className="float-up inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3 py-1.5 text-xs uppercase tracking-[0.2em] text-slate-300">
            <Sparkles className="w-3.5 h-3.5 text-[#F97316]" />
            Sahi Disha Freedom Planner
          </div>

          <h1
            className="float-up delay-100 mt-6 font-heading text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1.05] tracking-tighter glow-orange"
            data-testid="hero-title"
          >
            How much <span className="text-[#F97316]">SIP</span> is needed for
            <br className="hidden sm:block" /> your Monthly{" "}
            <span className="italic font-light text-slate-200">Passive Income?</span>
          </h1>

          <p className="float-up delay-200 mt-6 max-w-2xl text-base sm:text-lg text-slate-400 leading-relaxed">
            Calculate the exact SIP amount required today so your investments pay for your
            lifestyle — forever, even as inflation rises. Personalised for your age, expenses
            and freedom goal.
          </p>

          <div className="float-up delay-300 mt-10 flex flex-wrap items-center gap-4">
            <Button
              onClick={onPrimaryClick}
              className="bg-[#F97316] hover:bg-[#EA580C] text-white font-medium px-7 py-6 text-base rounded-md shadow-lg shadow-orange-500/20"
              data-testid="hero-start-btn"
            >
              Start My Plan
              <ArrowDown className="w-4 h-4 ml-2" />
            </Button>
            <a
              href="#about"
              className="text-sm text-slate-300 hover:text-white transition-colors underline-offset-4 hover:underline"
              data-testid="hero-about-link"
            >
              Why Sahi Disha?
            </a>
          </div>

          <dl className="float-up delay-400 mt-16 grid grid-cols-2 sm:grid-cols-4 gap-6 sm:gap-10 max-w-3xl">
            {[
              ["Perpetual", "Income stream"],
              ["Inflation-adjusted", "Every single year"],
              ["4 Step-up modes", "5 / 10 / 15 / 20%"],
              ["Branded PDF", "Ready to share"],
            ].map(([k, v]) => (
              <div key={k} className="border-l border-white/10 pl-4">
                <dt className="font-heading text-xl sm:text-2xl font-medium tracking-tight">
                  {k}
                </dt>
                <dd className="mt-1 text-xs uppercase tracking-[0.18em] text-slate-500">
                  {v}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}
